
import React from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';

const Summary: React.FC = () => {
  return (
    <section id="summary" className="py-5 text-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={12}>
            <Image src="/profile.jpeg" roundedCircle fluid style={{ width: '150px', height: '150px' }} className="mb-4" />
            <h1 className="mb-4">Andrei Skopenko</h1>
            <div className="mb-4">
              <Button variant="outline-primary" href="https://www.linkedin.com/in/scopenco/" target="_blank" rel="noopener noreferrer" className="me-2 mb-2">Connect on LinkedIn</Button>
              <Button variant="outline-secondary" href="https://github.com/scopenco" target="_blank" rel="noopener noreferrer" className="me-2 mb-2">Follow on GitHub</Button>
              <Button variant="outline-info" href="https://x.com/scopenco" target="_blank" rel="noopener noreferrer" className="me-2 mb-2">Follow on X</Button>
              <Button variant="outline-dark" href="https://t.me/scopenco" target="_blank" rel="noopener noreferrer" className="me-2 mb-2">Follow on Telegram</Button>
              <Button variant="outline-warning" href="https://medium.com/@skopenko" target="_blank" rel="noopener noreferrer" className="me-2 mb-2">Follow on Medium</Button>
            </div>
            <p className="lead">
              From Infrastructure guy to CTO. Focused on accelerating Delivery, Quality, and Profitability through Innovations.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Summary;
